<button
  type="button"
  class="option-select"
  [matMenuTriggerFor]="menu"
  [disabled]="disabled"
>
  <span>{{ selectedLabel }}</span>
  <span class="material-icons option-select__chevron">expand_more</span>
</button>

<mat-menu #menu="matMenu" class="option-select-panel">
  @for (opt of options; track opt.value) {
    <button mat-menu-item [class.active]="value === opt.value" (click)="select(opt.value)">{{ opt.label }}</button>
  }
</mat-menu>
